import React, {Fragment} from "react";
import {MapContainer, TileLayer} from "react-leaflet";
import L, {LatLng} from 'leaflet';
import './MapDisplay.css';

/**
 * Component displaying a world map and markers positioned on it.
 * @author Alizée Grand
 * @version 1.0
 * @creation 17/03/2022
 * @last_update 25/04/2022
 **/
class MapDisplay extends React.Component<{
    /**
     * Marker coordinates.
     */
    gpsCoordinates: LatLng[],
    /**
     * Markers to display.
     */
    markers: JSX.Element[]
}> {

    static MAP_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

    /**
     * Returns the list of coordinates formatted so that the map can be centered.
     */
    private generateBounds() {
        let bounds = undefined;
        if(this.props.gpsCoordinates.length > 0) {
            bounds = L.latLngBounds(this.props.gpsCoordinates);
        }
        return bounds;
    }

    render() {

        /**
         * Function to resize the map according to the size of its container.
         * Also allows you to center the map on the markers when the map is created.
         */
        const created = (map: L.Map) => {
            const bounds = this.generateBounds();
            setTimeout(() => {
                map.invalidateSize();
                if(bounds !== undefined && bounds.isValid()){
                    map.fitBounds(bounds);
                } else {
                    map.fitWorld();
                }
            }, 1000);
        }

        return (
            <MapContainer
                bounds={this.generateBounds()}
                scrollWheelZoom={true}
                id="mapContainer"
                whenCreated={created}>
                <TileLayer
                    attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                    url={MapDisplay.MAP_URL}
                />
                {
                    this.props.markers.map((marker, index) => (
                        <Fragment key={index}>
                            {marker}
                        </Fragment>
                    ))
                }
            </MapContainer>
        );
    }

}

export default MapDisplay;
